import React, {useEffect, useState} from "react";
// Use Forms
import {useForm} from "react-hook-form";
// React Bootstrap
import {Accordion, Button, Card, Col, Form} from "react-bootstrap";
// Utils
import {
  ingresosObraAlojamiento,
  ingresosObraEducativa,
  ingresosObraEspiritualidad,
  ingresosObras,
  ingresosObraSanitario,
  ingresosObraSocial,
  workCategories
} from "../../../../contexto";

const FormEconomicos = ({ defaultValues, submissionHandler, ...props }) => {
  const [validated] = useState(false);
  const { register, handleSubmit } = useForm({
    defaultValues: defaultValues,
  });

  // Comprueba si alguno de los campos de stjIncome, govermentIncome, fundeoIncome, otherIncome, donation
  // es true para establecer el valor del checkbox de autofinanciado
  const esAutofinanciada = () => {
    return !(defaultValues.stjIncome || defaultValues.governmentIncome || defaultValues.fundeoIncome || defaultValues.donation || defaultValues.otherIncome);

  };

  const [autofinanciado, setAutofinanciado] = useState(esAutofinanciada());

  // Devuelve un array de ingresos en función del tipo de obra
  const getArrayIngresos = () => {
    switch (defaultValues.category) {
      case workCategories[0]:
        return ingresosObraEducativa;
      case workCategories[1]:
        return ingresosObraAlojamiento;
      case workCategories[2]:
        return ingresosObraSanitario;
      case workCategories[3]:
        return ingresosObraEspiritualidad;
      case workCategories[4]:
        return ingresosObraSocial;
      default:
        return ingresosObras;
    }
  };

  // Hook con el array de los tipos de ingresos
  const [arrayIngresos, setArrayIngresos] = useState(getArrayIngresos());

  // UEF que controla cuando el tipo cambia se cambie el array de los ingresos
  useEffect(() => {
    setArrayIngresos(getArrayIngresos());
  }, [defaultValues?.type]);

  // Función que genera el objeto que necesita la petición para añadir o eliminar ingresos
  const getObjIngresos = (misIngresos) => {
    const obj = {
      incomeAdd: [],
      incomeRemove: [],
    };
    arrayIngresos.forEach((tipo) => {
      if (misIngresos[tipo]) {
        obj.incomeAdd.push(tipo);
      } else {
        obj.incomeRemove.push(tipo);
      }
    });
    return obj;
  };

  // On submit del formulario
  const onSubmit = (data) => {
    // Si es autofinanciado los datos se envian a false
    if (autofinanciado) {
      data.stjIncome = false;
      data.governmentIncome = false;
      data.fundeoIncome = false;
      data.otherIncome = false;
      data.donation = false;
    }
    data.objIngresos = getObjIngresos(data);
    submissionHandler(data);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <small className="mb-3">
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>
      <Accordion defaultActiveKey="0" className="mb-2">
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            Financiada por
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <Form.Group as={Col} xs={12} md controlId="autofinanciado-datosEconomicos">
                <Form.Check
                  custom
                  id="autofinanciado"
                  label={"Autofinanciado"}
                  name="autofinanciado"
                  checked={autofinanciado}
                  onClick={() => {
                    setAutofinanciado(!autofinanciado);
                  }}
                  value={autofinanciado}
                />
              </Form.Group>

              {!autofinanciado && (
                <>
                  <Form.Group as={Col} xs={12} md controlId="stjIncome-datosEconomicos">
                    <Form.Check custom id="stjIncome" label={"STJ"} name="stjIncome" {...register("stjIncome", {})} />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} md controlId="governmentIncome-datosEconomicos">
                    <Form.Check custom id="governmentIncome" label={"Gobierno"} name="governmentIncome" {...register("governmentIncome", {})} />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} md controlId="fundeoIncome-datosEconomicos">
                    <Form.Check custom id="fundeoIncome" label={"FUNDEO"} name="fundeoIncome" {...register("fundeoIncome", {})} />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} md controlId="donation-datosEconomicos">
                    <Form.Check custom id="donation" label={"Donaciones"} name="donation" {...register("donation", {})} />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} md controlId="otherIncome-datosEconomicos">
                    <Form.Check custom id="otherIncome" label={"Otros"} name="otherIncome" {...register("otherIncome", {})} />
                  </Form.Group>
                </>
              )}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
      {arrayIngresos.length && defaultValues.type === "Obra" && (
        <Accordion defaultActiveKey="0" className="mb-2">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              Ingresos
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                {arrayIngresos.map((tipo) => (
                  <Form.Group as={Col} xs={12} md controlId={tipo + "-datosEconomicos"}>
                    <Form.Check
                      custom
                      label={tipo}
                      name={tipo}
                      key={tipo}
                      defaultChecked={defaultValues.datosIngresos.length && defaultValues.datosIngresos.find((f) => f.type === tipo)}
                      {...register(tipo, {})}
                    />
                  </Form.Group>
                ))}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      )}
      <Form.Row >
        <Form.Group as={Col} xs={12} md controlId="accounting-datosEconomicos">
          <Form.Check custom id="accounting" label={"Contabilidad STJ"} name="accounting" {...register("accounting", {})} />
        </Form.Group>
      </Form.Row>
      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormEconomicos;
